module.exports = __webpack_public_path__ + "img/loadingImg.2de23449.png";